import React from "react";
import logo from "../assets/logo.svg";

const Logo = ({ width = 180 }) => {
  return <img src={logo} alt="PrimeQA Solutions" width={width} />;
};

export default Logo;
